import { useGetContextLocationQuery } from "../api/AdminLocationsApi";
import { useSlugs } from "./useSlugs";
import { Location } from "../../../models/Location";
import { useMemo } from "react";

export const useContextLocation = (): Location => {
  const {brandSlug, locationSlug} = useSlugs();
  const {data} = useGetContextLocationQuery({brandSlug, locationSlug}, {skip: !brandSlug || !locationSlug});

  return useMemo(() => {
    return data ? {...data, id: data.id ?? "all"} : {};
  }, [data]);
};
